<script setup lang="ts">
/**
 * Статус задачи — макет 12:353: точка цвета колонки и её имя в пилюле.
 *
 * Статус в трекере — это и есть колонка доски, отдельной сущности нет. На доске
 * задачу называет колонка, в которой она лежит, а в списке колонок нет — здесь
 * пилюля единственное, что отвечает на вопрос «где задача».
 *
 * Цвет один на три роли: точка красится им, текст — им же, притянутым к цвету
 * текста, фон — им же, разбавленным до тинта. Так пилюля работает с любым
 * цветом колонки (их задаёт человек в настройках) и в обеих темах, не требуя
 * заводить палитру на каждый оттенок.
 */
import { computed } from 'vue'

const props = defineProps<{
  name: string
  /** Цвет колонки; пусто — нейтральная пилюля */
  color: string
}>()

const tint = computed(() => props.color || 'var(--color-text-muted)')
</script>

<template>
  <span
    class="sbadge"
    :style="{
      '--sbadge-color': tint,
      background: `color-mix(in srgb, ${tint} 12%, transparent)`,
      color: `color-mix(in srgb, ${tint} 60%, var(--color-text-primary))`,
    }"
  >
    <span class="sbadge__dot" aria-hidden="true" />
    <span class="sbadge__name">{{ name }}</span>
  </span>
</template>

<style scoped>
.sbadge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 100%;
  height: 20px;
  padding: 0 8px;
  border-radius: var(--radius-full);
  font-size: var(--font-size-caption);
  line-height: 16px;
}

.sbadge__dot {
  flex-shrink: 0;
  width: 6px;
  height: 6px;
  border-radius: var(--radius-full);
  background: var(--sbadge-color);
}

.sbadge__name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
